import { get } from 'lodash';
import { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

// APIS
import { createBatch, getAllBatches } from 'src/axiosLib/services/batch/admin';
import { createBranch, getAllBranches } from 'src/axiosLib/services/branch/admin';
import { createSubject, getAllSubjects, listAllSubjectsWithChapters } from 'src/axiosLib/services/subject/admin';
import { createChapter, deleteChapter } from 'src/axiosLib/services/chapter/admin';
// material
import {
  Button,
  Card,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  Box,
  IconButton,
  Collapse,
  Divider,
  Chip,
} from '@mui/material';
// components
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import Iconify from '../../components/Iconify';
import { UserListHead } from '../../sections/@dashboard/user';
import { Icon } from '@iconify/react';
import moment from 'moment';
import { Edit, Delete, ExpandMore, ExpandLess, Add } from '@mui/icons-material';

const SUBJECT_ICONS = [
  'mdi:dna', 'mdi:atom', 'mdi:flask-round-bottom', 'mdi:book-open-variant', 'mdi:earth',
  'mdi:calculator', 'mdi:brain', 'mdi:school', 'mdi:microscope', 'mdi:leaf',
  'mdi:music', 'mdi:palette', 'mdi:code-braces', 'mdi:chart-line', 'mdi:translate',
  'mdi:history', 'mdi:gavel', 'mdi:hospital-building', 'mdi:pill', 'mdi:stethoscope', 'mdi:orbit',
];
const SUBJECT_COLORS = [
  '#16a34a', '#2563eb', '#dc2626', '#9333ea', '#ea580c',
  '#0891b2', '#d946ef', '#4338ca', '#0d9488', '#ca8a04',
];

// ----------------------------------------------------------------------

const TABLE_HEAD_BATCH = [
  { id: 'name', label: 'Branch Name', alignRight: false },
  { id: 'address', label: 'Branch Address', alignRight: false },
  // { id: 'session', label: 'Session', alignRight: false },
  { id: 'email', label: 'Contact Email', alignRight: false },
  // { id: 'email', label: 'Phone', alignRight: false },
  { id: 'updatedAt', label: 'Updated At', alignRight: false },
  // { id: 'registered_at', label: 'Registered at', alignRight: false },
  { id: 'profile', label: 'EDIT', alignRight: false },
];

const TABLE_HEAD_BRANCH = [
  { id: 'name', label: 'Batch Name', alignRight: false },
  { id: 'branch', label: 'Branch Name', alignRight: false },
  // { id: 'session', label: 'Session', alignRight: false },
  { id: 'phone', label: 'Phone', alignRight: false },
  { id: 'updatedAt', label: 'Updated At', alignRight: false },
  // { id: 'registered_at', label: 'Registered at', alignRight: false },
  { id: 'profile', label: 'EDIT', alignRight: false },
];

const TABLE_HEAD_SUBJECT = [
  { id: 'icon', label: 'Icon', alignRight: false },
  { id: 'name', label: 'Subject Name', alignRight: false },
  { id: 'code', label: 'Subject Code', alignRight: false },
  { id: 'chapters', label: 'Chapters', alignRight: false },
  { id: 'updatedAt', label: 'Last Updated At', alignRight: false },
  { id: 'profile', label: 'EDIT', alignRight: false },
];
// ----------------------------------------------------------------------

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

export default function User() {
  const [branchModal, setBranchModal] = useState(false);
  const [batchModal, setBatchModal] = useState(false);
  const [subjectModal, setSubjectModal] = useState(false);

  const [batchData, setBatchData] = useState();
  const [branchData, setBranchData] = useState();
  const [subjectData, setSubjectData] = useState();
  const [expandedSubject, setExpandedSubject] = useState(null);
  const [subjectChapters, setSubjectChapters] = useState({});
  const [newChapterName, setNewChapterName] = useState('');
  const [fullSubjects, setFullSubjects] = useState([]);

  const navigate = useNavigate();

  const [page, setPage] = useState(0);

  const [pageB, setPageB] = useState(0);

  const [pageSub, setPageSub] = useState(0);

  const [order, setOrder] = useState('asc');

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [rowsPerPageSub, setRowsPerPageSub] = useState(5);

  const [rowsPerPageB, setRowsPerPageB] = useState(5);

  const [batchList, setBatchList] = useState([]);

  const [batchCount, setBatchCount] = useState(0);

  const [branchList, setBranchList] = useState([]);

  const [branchCount, setBranchCount] = useState(0);

  const [subjectList, setSubjectList] = useState([]);

  const [subjectCount, setSubjectCount] = useState(0);

  const handleBatchDataChange = (fieldName, event) => {
    // console.log(event.target.value);
    setBatchData({ ...batchData, [fieldName]: event.target.value });
  };

  const handleBranchDataChange = (fieldName, event) => {
    // console.log(event.target.value);
    setBranchData({ ...branchData, [fieldName]: event.target.value });
  };

  const handleSubjectDataChange = (fieldName, event) => {
    // console.log(event.target.value);
    setSubjectData({ ...subjectData, [fieldName]: event.target.value });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangePageBranch = (event, newPage) => {
    setPageB(newPage);
  };

  const handleChangePageSubject = (event, newPage) => {
    setPageSub(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    // setPage(0);
  };

  const handleChangeRowsPerPageBranch = (event) => {
    setRowsPerPageB(event.target.value);
    // setPage(0);
  };

  const handleChangeRowsPerPageSubject = (event) => {
    setRowsPerPageSub(event.target.value);
    // setPage(0);
  };

  const handleFilterByName = (event) => {
    const filterValue = event.target.value;
    setPage(0);
    setRowsPerPage(10);
    setFilterName(filterValue);
  };

  const getBatches = (rowsPerPage, page) => {
    try {
      getAllBatches(rowsPerPage, page, (error, data) => {
        if (!error) {
          // console.log(data);
          setBatchList(get(data, 'batches', []));
          setBatchCount(get(data, 'size', 0));
        } else {
          console.log(error);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const getBranches = (rowsPerPageB, pageB) => {
    try {
      getAllBranches(rowsPerPageB, pageB, (error, data) => {
        if (!error) {
          // console.log(data);
          setBranchList(get(data, 'branches', []));
          setBranchCount(get(data, 'size', 0));
        } else {
          console.log(error);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const getSubjects = (rowsPerPageSub, pageSub) => {
    try {
      getAllSubjects(rowsPerPageSub, pageSub, (error, data) => {
        if (!error) {
          // console.log(data);
          setSubjectList(get(data, 'subjects', []));
          setSubjectCount(get(data, 'size', 0));
        } else {
          navigate('/login', { replace: true });
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleBatchEdit = (row) => {
    const temp = {
      _id: get(row, '_id', ''),
      batchName: get(row, 'batchName', ''),
    };

    setBatchData(temp);

    setBatchModal(true);
  };

  const handleBranchEdit = (row) => {
    const temp = {
      _id: get(row, '_id', ''),
      address: get(row, 'address', ''),
      branchName: get(row, 'branchName', ''),
      email: get(row, 'email', ''),
      mobile: get(row, 'mobile', ''),
    };

    setBranchData(temp);

    setBranchModal(true);
  };

  const handleSubjectEdit = (row) => {
    const temp = {
      _id: get(row, '_id', ''),
      subjectCode: get(row, 'subjectCode', ''),
      name: get(row, 'name', ''),
      icon: get(row, 'icon', 'mdi:book-open-variant'),
      color: get(row, 'color', '#4338ca'),
    };

    setSubjectData(temp);

    setSubjectModal(true);
  };

  const loadFullSubjects = () => {
    listAllSubjectsWithChapters((err, data) => {
      if (!err && Array.isArray(data)) {
        setFullSubjects(data);
        const chapMap = {};
        data.forEach(s => { chapMap[s._id] = s.chapters || []; });
        setSubjectChapters(chapMap);
      }
    });
  };

  const handleToggleSubjectExpand = (subjectId) => {
    setExpandedSubject(expandedSubject === subjectId ? null : subjectId);
  };

  const handleAddChapter = (subjectId) => {
    if (!newChapterName.trim()) return;
    createChapter({ chapterName: newChapterName.trim(), subjectId }, (err) => {
      if (!err) {
        setNewChapterName('');
        loadFullSubjects();
      }
    });
  };

  const handleDeleteChapter = (chapterId) => {
    deleteChapter({ chapterId }, (err) => {
      if (!err) loadFullSubjects();
    });
  };

  const insertBatch = () => {
    createBatch(batchData, (error, data) => {
      if (!error) {
        // console.log(data);

        // dashboard/institute
        // navigate('/dashboard/institute', { replace: true });
        // console.log(data);
        window.location.reload(false);
      } else {
        console.log(error);
      }
    });

    // setBatchModal(false)
  };

  const insertBranch = () => {
    createBranch(branchData, (error, data) => {
      if (!error) {
        // console.log(data);

        // navigate('/dashboard/institute', { replace: true });
        window.location.reload(false);
      } else {
        console.log(error);
      }
    });

    // setBranchModal(false)
  };

  const insetSubject = () => {
    createSubject(subjectData, (error, data) => {
      if (!error) {
        // console.log(data);

        window.location.reload(false);
      } else {
        alert('Something went wrong');
      }
    });

    // setSubjectModal(false)
  };

  useEffect(() => {
    getBatches(rowsPerPage, page);
  }, [page, rowsPerPage]);

  useEffect(() => {
    getBranches(rowsPerPageB, pageB);
  }, [rowsPerPageB, pageB]);

  useEffect(() => {
    getSubjects(rowsPerPageSub, pageSub);
    loadFullSubjects();
  }, [rowsPerPageSub, pageSub]);

  return (
    <Page title="Institute Details">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h3" gutterBottom>
            Institute Details
          </Typography>
        </Stack>

        {/* Batch */}
        <Card>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={4}>
            <Typography
              variant="h4"
              gutterBottom
              style={{ marginLeft: 15, color: '#FF0000', backgroundColor: 'white' }}
            >
              Batch Information
            </Typography>
            <Button
              style={{ marginRight: 10 }}
              variant="contained"
              component={RouterLink}
              to="#"
              startIcon={<Iconify icon="eva:plus-fill" />}
              onClick={() => handleBatchEdit({})}
            >
              Add New Batch
            </Button>
          </Stack>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD_BRANCH}
                  rowCount={batchList.length}
                />
                <TableBody>
                  {batchList.map((row) => {
                    return (
                      <TableRow hover key={get(row, '_id', '')} tabIndex={-1}>
                        <TableCell align="left"> {get(row, 'batchName', '')}</TableCell>
                        <TableCell align="left"> {get(row, 'branchId.branchName', '')}</TableCell>
                        <TableCell align="left"> {get(row, 'branchId.mobile', '')}</TableCell>

                        <TableCell align="left">
                          {' '}
                          {
                            <TextField
                              id="date"
                              label="Batch Last Modified"
                              type="date"
                              defaultValue={moment(row.updatedAt).format('yyyy-MM-DD')}
                              // onChange={() => { console.log('changing date') }}
                              sx={{ width: 220 }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          }
                        </TableCell>
                        <TableCell align="left">
                          {' '}
                          {
                            <Button
                              variant="contained"
                              onClick={() => handleBatchEdit(row)}
                              style={{ color: '#880ED4', backgroundColor: 'white' }}
                            >
                              <Edit style={{ color: '#880ED4', marginRight: 5 }} /> EDIT BATCH
                            </Button>
                          }
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 100]}
            component="div"
            count={batchCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>

        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={10}>
          {' '}
        </Stack>

        {/* Branch */}

        <Card>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={4}>
            <Typography
              variant="h4"
              gutterBottom
              style={{ marginLeft: 15, color: '#FF0000', backgroundColor: 'white' }}
            >
              Branch Information
            </Typography>
            <Button
              style={{ marginRight: 10 }}
              variant="contained"
              component={RouterLink}
              to="#"
              startIcon={<Iconify icon="eva:plus-fill" />}
              onClick={() => handleBranchEdit({})}
            >
              Add New Branch
            </Button>
            {/* <NewBranch open = {open} onClick={() => setOpen(true)}/> */}
          </Stack>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD_BATCH}
                  rowCount={branchList.length}
                />
                <TableBody>
                  {branchList.map((row) => {
                    return (
                      <TableRow hover key={get(row, '_id', '')} tabIndex={-1}>
                        <TableCell align="left"> {get(row, 'branchName', '')}</TableCell>
                        <TableCell align="left"> {get(row, 'address', '')}</TableCell>
                        <TableCell align="left"> {get(row, 'email', '')}</TableCell>

                        <TableCell align="left">
                          {' '}
                          {
                            <TextField
                              id="date"
                              label="Batch Last Modified"
                              type="date"
                              defaultValue={moment(get(row, 'updatedAt', '')).format('yyyy-MM-DD')}
                              onChange={() => {
                                console.log('changing date');
                              }}
                              sx={{ width: 220 }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          }
                        </TableCell>
                        <TableCell align="left">
                          {' '}
                          {
                            <Button
                              variant="contained"
                              onClick={() => handleBranchEdit(row)}
                              style={{ color: '#880ED4', backgroundColor: 'white' }}
                            >
                              <Edit style={{ color: '#880ED4', marginRight: 5 }} /> EDIT
                            </Button>
                          }
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 100]}
            component="div"
            count={branchCount}
            rowsPerPage={rowsPerPageB}
            page={pageB}
            onPageChange={handleChangePageBranch}
            onRowsPerPageChange={handleChangeRowsPerPageBranch}
          />
        </Card>

        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={10}>
          {' '}
        </Stack>

        {/* Subject */}
        <Card>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={4}>
            <Typography
              variant="h4"
              gutterBottom
              style={{ marginLeft: 15, color: '#FF0000', backgroundColor: 'white' }}
            >
              Subjects List
            </Typography>
            <Button
              style={{ marginRight: 10 }}
              variant="contained"
              component={RouterLink}
              to="#"
              startIcon={<Iconify icon="eva:plus-fill" />}
              onClick={() => handleSubjectEdit({})}
            >
              Add New Subject
            </Button>
          </Stack>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD_SUBJECT}
                  rowCount={subjectList.length}
                />
                <TableBody>
                  {subjectList.map((row) => {
                    const subjectColor = row.color || '#4338ca';
                    const subjectIcon = row.icon || 'mdi:book-open-variant';
                    const chapters = subjectChapters[row._id] || [];
                    return (
                      <>
                      <TableRow hover key={get(row, '_id', '')} tabIndex={-1}>
                        <TableCell align="left">
                          <Box sx={{
                            width: 36, height: 36, borderRadius: 1.5, display: 'flex',
                            alignItems: 'center', justifyContent: 'center',
                            background: `${subjectColor}15`,
                          }}>
                            <Icon icon={subjectIcon} style={{ fontSize: 20, color: subjectColor }} />
                          </Box>
                        </TableCell>
                        <TableCell align="left">
                          <Stack direction="row" spacing={1} alignItems="center">
                            <Box sx={{ width: 8, height: 8, borderRadius: '50%', background: subjectColor, flexShrink: 0 }} />
                            <span>{get(row, 'name', '')}</span>
                          </Stack>
                        </TableCell>
                        <TableCell align="left"> {get(row, 'subjectCode', '')}</TableCell>
                        <TableCell align="left">
                          <Button size="small" onClick={() => handleToggleSubjectExpand(row._id)}
                            endIcon={expandedSubject === row._id ? <ExpandLess /> : <ExpandMore />}
                            sx={{ textTransform: 'none', fontSize: '0.8rem' }}>
                            {chapters.length} chapters
                          </Button>
                        </TableCell>
                        <TableCell align="left">
                          <TextField
                            id="date"
                            label="Last Modified"
                            type="date"
                            defaultValue={moment(get(row, 'updatedAt', '')).format('yyyy-MM-DD')}
                            sx={{ width: 180 }}
                            InputLabelProps={{ shrink: true }}
                            size="small"
                          />
                        </TableCell>
                        <TableCell align="left">
                          <Button
                            variant="contained"
                            onClick={() => handleSubjectEdit(row)}
                            style={{ color: '#880ED4', backgroundColor: 'white' }}
                          >
                            <Edit style={{ color: '#880ED4', marginRight: 5 }} /> EDIT
                          </Button>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colSpan={6} sx={{ py: 0, borderBottom: expandedSubject === row._id ? undefined : 'none' }}>
                          <Collapse in={expandedSubject === row._id}>
                            <Box sx={{ py: 2, px: 2, background: '#fafafa', borderRadius: 1, my: 1 }}>
                              <Typography sx={{ fontWeight: 700, fontSize: '0.85rem', mb: 1 }}>Chapters</Typography>
                              {chapters.length === 0 && (
                                <Typography sx={{ color: '#888', fontSize: '0.8rem' }}>No chapters yet</Typography>
                              )}
                              {chapters.map((ch, ci) => (
                                <Stack key={ch._id} direction="row" alignItems="center" spacing={1}
                                  sx={{ py: 0.4, px: 1, borderRadius: 1, '&:hover': { background: '#f1f1f1' } }}>
                                  <Typography sx={{ flex: 1, fontSize: '0.82rem', color: '#444' }}>
                                    {ci + 1}. {ch.chapterName}
                                  </Typography>
                                  <IconButton size="small" onClick={() => handleDeleteChapter(ch._id)}
                                    sx={{ color: '#ef4444', opacity: 0.5, '&:hover': { opacity: 1 } }}>
                                    <Delete fontSize="small" />
                                  </IconButton>
                                </Stack>
                              ))}
                              <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                                <TextField size="small" placeholder="New chapter name" fullWidth
                                  value={expandedSubject === row._id ? newChapterName : ''}
                                  onChange={(e) => setNewChapterName(e.target.value)}
                                  onKeyPress={(e) => { if (e.key === 'Enter') handleAddChapter(row._id); }}
                                />
                                <Button size="small" variant="outlined" startIcon={<Add />}
                                  onClick={() => handleAddChapter(row._id)}
                                  sx={{ whiteSpace: 'nowrap' }}>
                                  Add
                                </Button>
                              </Stack>
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                      </>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 100]}
            component="div"
            count={subjectCount}
            rowsPerPage={rowsPerPageSub}
            page={pageSub}
            onPageChange={handleChangePageSubject}
            onRowsPerPageChange={handleChangeRowsPerPageSubject}
          />
        </Card>

        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={10}>
          {' '}
        </Stack>

        {/* BATCH MODAL*/}
        <div>
          <Dialog open={batchModal} onClose={() => setBatchModal(false)}>
            <DialogTitle>Batch Info</DialogTitle>
            <DialogContent>
              <TextField
                name="batchName"
                label="Batch Name"
                style={{ width: '100%', marginTop: 20 }}
                value={get(batchData, 'batchName', '')}
                onChange={(e) => {
                  handleBatchDataChange('batchName', e);
                }}
                required
              />

              <FormControl fullWidth required style={{ width: '100%', marginTop: 20 }}>
                <InputLabel id="sessiom-label">Branch</InputLabel>
                <Select
                  // labelId="session"
                  id="session-label"
                  value={get(batchData, 'branchId', '')}
                  label="Branch"
                  onChange={(e) => {
                    handleBatchDataChange('branchId', e);
                  }}
                >
                  {branchList.map((branch) => (
                    <MenuItem key={branch.branchName} value={branch._id}>
                      {branch.branchName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </DialogContent>

            <DialogActions>
              <Button variant="contained" onClick={insertBatch} style={{ color: 'white', backgroundColor: 'blue' }}>
                ADD / EDIT
              </Button>
            </DialogActions>
          </Dialog>
        </div>

        {/* BRANCH MODAL */}
        <div>
          <Dialog open={branchModal} onClose={() => setBranchModal(false)}>
            <DialogTitle>Branch Info</DialogTitle>
            <DialogContent>
              <TextField
                name="branchName"
                label="Branch Name"
                style={{ width: '100%', marginTop: 20 }}
                value={get(branchData, 'branchName', '')}
                onChange={(e) => {
                  handleBranchDataChange('branchName', e);
                }}
                required
              />

              <TextField
                name="email"
                label="Email"
                style={{ width: '100%', marginTop: 20 }}
                value={get(branchData, 'email', '')}
                onChange={(e) => {
                  handleBranchDataChange('email', e);
                }}
                required
              />

              <TextField
                name="mobile"
                label="Mobile Number"
                style={{ width: '100%', marginTop: 20 }}
                value={get(branchData, 'mobile', '')}
                onChange={(e) => {
                  handleBranchDataChange('mobile', e);
                }}
                required
              />

              <TextField
                name="address"
                label="Address"
                style={{ width: '100%', marginTop: 20 }}
                value={get(branchData, 'address', '')}
                onChange={(e) => {
                  handleBranchDataChange('address', e);
                }}
                required
              />
            </DialogContent>

            <DialogActions>
              <Button variant="contained" onClick={insertBranch} style={{ color: 'white', backgroundColor: 'blue' }}>
                ADD / EDIT
              </Button>
            </DialogActions>
          </Dialog>
        </div>

        <div>
          <Dialog open={subjectModal} onClose={() => setSubjectModal(false)} maxWidth="sm" fullWidth>
            <DialogTitle>Subject Info</DialogTitle>

            <DialogContent>
              <Stack spacing={2} sx={{ mt: 1 }}>
                <Stack direction="row" spacing={2}>
                  <TextField
                    name="name"
                    label="Subject Name"
                    fullWidth
                    value={get(subjectData, 'name', '')}
                    onChange={(e) => handleSubjectDataChange('name', e)}
                    required
                  />
                  <TextField
                    name="subjectCode"
                    label="Subject Code"
                    fullWidth
                    value={get(subjectData, 'subjectCode', '')}
                    onChange={(e) => handleSubjectDataChange('subjectCode', e)}
                    required
                  />
                </Stack>

                <Divider />
                <Typography sx={{ fontWeight: 600, fontSize: '0.85rem', color: '#555' }}>Choose Icon</Typography>
                <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
                  {SUBJECT_ICONS.map(ic => (
                    <IconButton key={ic} size="small"
                      onClick={() => setSubjectData({ ...subjectData, icon: ic })}
                      sx={{
                        border: get(subjectData, 'icon', 'mdi:book-open-variant') === ic
                          ? `2px solid ${get(subjectData, 'color', '#4338ca')}`
                          : '1px solid #e5e7eb',
                        borderRadius: 1, p: 0.6,
                        background: get(subjectData, 'icon', 'mdi:book-open-variant') === ic
                          ? `${get(subjectData, 'color', '#4338ca')}15`
                          : 'transparent',
                      }}>
                      <Icon icon={ic} style={{
                        fontSize: 18,
                        color: get(subjectData, 'icon', 'mdi:book-open-variant') === ic
                          ? get(subjectData, 'color', '#4338ca')
                          : '#999'
                      }} />
                    </IconButton>
                  ))}
                </Stack>

                <Typography sx={{ fontWeight: 600, fontSize: '0.85rem', color: '#555' }}>Choose Color</Typography>
                <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
                  {SUBJECT_COLORS.map(c => (
                    <Box key={c} onClick={() => setSubjectData({ ...subjectData, color: c })}
                      sx={{
                        width: 28, height: 28, borderRadius: 1, background: c, cursor: 'pointer',
                        border: get(subjectData, 'color', '#4338ca') === c ? '3px solid #333' : '1px solid #ddd',
                        transition: 'all 0.15s',
                        '&:hover': { transform: 'scale(1.15)' },
                      }} />
                  ))}
                </Stack>

                {/* Preview */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, p: 1.5, borderRadius: 2, background: '#f8f8f8' }}>
                  <Box sx={{
                    width: 40, height: 40, borderRadius: 1.5, display: 'flex',
                    alignItems: 'center', justifyContent: 'center',
                    background: `${get(subjectData, 'color', '#4338ca')}15`,
                  }}>
                    <Icon icon={get(subjectData, 'icon', 'mdi:book-open-variant')}
                      style={{ fontSize: 22, color: get(subjectData, 'color', '#4338ca') }} />
                  </Box>
                  <Typography sx={{ fontWeight: 700 }}>{get(subjectData, 'name', 'Preview')}</Typography>
                </Box>
              </Stack>
            </DialogContent>

            <DialogActions>
              <Button onClick={() => setSubjectModal(false)}>Cancel</Button>
              <Button variant="contained" onClick={insetSubject}
                sx={{ background: 'linear-gradient(45deg, #4338ca, #6366f1)' }}>
                SAVE
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </Container>
    </Page>
  );
}
